import React,{Component} from 'react';
import { Modal } from 'react-bootstrap';
import {Button} from "shards-react";

export default class ConfirmModal extends Component {
  render(){
  return (
    <Modal show={this.props.show} onHide={this.props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.props.message}</Modal.Body>
        <Modal.Footer>
          <Button   theme="info" onClick={this.props.handleClose}>
            Close
          </Button>
          <Button theme="danger" onClick={this.props.onAccept}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
